import { AnalysisSet, ComponentDesignWithInformation } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function get(analysisGuid: string, sharedComponentSetLookupCode?: string): Promise<AnalysisSet> {
  return DesignService.get(
    `analysisSets/${analysisGuid}`,
    sharedComponentSetLookupCode ? { params: new URLSearchParams({ sharedComponentSetLookupCode }) } : undefined,
  );
}

export function fetchComponentsFromAnalysisSets(
  analysisSetGuids: string[],
): Promise<{ [analysisSetGuid: string]: ComponentDesignWithInformation }> {
  return DesignService.post('analysisSets/fetchComponentsFromAnalysisSets', { data: analysisSetGuids });
}
